module.exports = __webpack_public_path__ + "img/img99.b9847b16.png";